module.exports = __webpack_public_path__ + "static/media/kiss.930b0710.svg";